var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1296,
    height: 288,
    viewBox: "0 0 1296 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_597_2047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.423 104.398L808.823 173.998L878.423 243.598L948.023 173.998L878.423 104.398Z",
    fill: "#EAECF0"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "0.1s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M843.63 139.201L808.83 174.001L843.63 208.801L878.43 174.001L843.63 139.201Z",
    fill: "#F2F4F7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "0.2s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M821.878 139.198L787.078 173.998L821.878 208.798L856.678 173.998L821.878 139.198Z",
    fill: "#F9FAFB"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "0.3s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1296.02 243.597L1365.62 173.997L1296.02 104.397L1226.42 173.997L1296.02 243.597Z",
    fill: "#F2F4F7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "0.4s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1122.02 348L1296.02 174L1122.02 3.29265e-05L948.018 174L1122.02 348Z",
    fill: "#F9FAFB"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1052.42 348L1226.42 174L1052.42 0.000154997L878.419 174L1052.42 348Z",
    fill: "#EAECF0"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "0.6s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M982.818 278.4L1087.22 174L982.818 69.6003L878.418 174L982.818 278.4Z",
    fill: "#F2F4F7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "0.7s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1017.63 243.597L1087.23 173.997L1017.63 104.398L948.025 173.998L1017.63 243.597Z",
    fill: "#D0D5DD"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "0.8s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1122.02 278.4L1226.42 174L1122.02 69.6L1017.62 174L1122.02 278.4Z",
    fill: "#D0D5DD"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "0.9s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1087.22 243.597L1156.82 173.997L1087.22 104.397L1017.63 173.997L1087.22 243.597Z",
    fill: "#FCFCFD"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "1s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1122.02 208.8L1156.82 174L1122.02 139.2L1087.22 174L1122.02 208.8Z",
    fill: "#EAECF0"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "1.1s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M808.818 202.751L739.219 272.351L808.818 341.951L878.418 272.351L808.818 202.751Z",
    fill: "#FFD6AE"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "1.2s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M774.025 237.554L739.225 272.354L774.025 307.154L808.825 272.354L774.025 237.554Z",
    fill: "#FFE6D5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "1.3s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M752.273 237.55L717.473 272.35L752.273 307.15L787.073 272.35L752.273 237.55Z",
    fill: "#FFF4ED"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "1.4s"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.514 -0.00378861L425.914 69.5962L495.514 139.196L565.114 69.5962L495.514 -0.00378861Z",
    fill: "#FFD6AE"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "1.5s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M460.721 34.7988L425.921 69.5988L460.721 104.399L495.521 69.5988L460.721 34.7988Z",
    fill: "#FFE6D5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "1.6s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M438.968 34.7957L404.168 69.5956L438.968 104.396L473.768 69.5957L438.968 34.7957Z",
    fill: "#FFF4ED"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "1.7s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M913.115 139.195L982.715 69.5948L913.115 -0.0051152L843.515 69.5949L913.115 139.195Z",
    fill: "#FFE6D5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "1.8s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1204.65 139.195L1274.25 69.5948L1204.65 -0.0051152L1135.05 69.5949L1204.65 139.195Z",
    fill: "#FFE6D5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "1.9s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M739.109 243.598L913.109 69.5981L739.109 -104.402L565.109 69.5981L739.109 243.598Z",
    fill: "#FFF4ED"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "2s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M669.509 243.598L843.509 69.5982L669.509 -104.402L495.509 69.5982L669.509 243.598Z",
    fill: "#FFD6AE"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "2.1s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M599.909 173.998L704.309 69.5984L599.909 -34.8016L495.509 69.5984L599.909 173.998Z",
    fill: "#FFE6D5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "2.2s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M634.716 139.196L704.316 69.5956L634.716 -0.00438278L565.116 69.5956L634.716 139.196Z",
    fill: "#FF9C66"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "2.3s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M739.109 173.998L843.509 69.5981L739.109 -34.8019L634.709 69.5981L739.109 173.998Z",
    fill: "#FF9C66"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "2.4s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M704.315 139.195L773.915 69.5953L704.315 -0.00462692L634.715 69.5954L704.315 139.195Z",
    fill: "#FFF9F5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "2.5s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M947.909 104.398L982.708 69.5975L947.909 34.7975L913.109 69.5975L947.909 104.398Z",
    fill: "#FFF4ED"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "2.6s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M969.662 104.394L1004.46 69.5944L969.662 34.7944L934.862 69.5944L969.662 104.394Z",
    fill: "#FF9C66"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "2.7s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M739.109 104.398L773.909 69.5981L739.109 34.7981L704.309 69.5981L739.109 104.398Z",
    fill: "#FFD6AE"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "2.8s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1239.45 104.398L1274.25 69.5975L1239.45 34.7975L1204.65 69.5975L1239.45 104.398Z",
    fill: "#FFF4ED"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "2.9s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1261.2 104.394L1296 69.5944L1261.2 34.7944L1226.4 69.5944L1261.2 104.394Z",
    fill: "#FF9C66"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "3s"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_597_2047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1296,
    height: 288,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.32f4a36b5cdc72e411c4b6c57eb978f8.svg";
export { ForwardRef as ReactComponent };